export default __webpack_public_path__ + "static/media/bc-four.4a694b46.svg";